// @flow

/**
 * This is a helper function that is used for generating a set of ranges. The main reason
 * was for creating an Array of sizes for responsive images.
 *
 * What it does is generating a number range with a start and an inclusive end, with gaps
 * of step.
 *
 * That means it allows you to generate an Array like [100, 200, 300, 400] with the following
 * call:
 *
 * numberRangeForStep(100, 400, 100); // read it like: from 100 to 400 with steps of 100.
 *
 * The function allows you to create a descending range as well (enter negative numbers). It
 * errors when the end is not reachable.
 *
 * @param Number start: inclusive start of your range
 * @param Number end: inclusive end of your range
 * @param Number step: amount of increment per array entry.
 */
const numberRangeForStep = (start: number, end: number, step: number): Array<number> => {
  if ((start > end && step > 0) || (start < end && step < 0) || step === 0) {
    throw new Error('End not reachable');
  }

  // We need Math.abs because we should be able to deal with negative values.
  const arraySize = Math.abs(Math.floor((end - start) / step) + 1);
  return Array.from(new Array((arraySize)), (_, i) => start + (i * step));
};

export default numberRangeForStep;
